import React from 'react'
import { Badge } from 'react-bootstrap'

export const Tag = ({ value }: any) => {
  return <Badge>{value}</Badge>
}
